// extracted by mini-css-extract-plugin
module.exports = {"PreviewArea":"styles_PreviewArea__keqSP"};